import mastercardLogo from "../assets/master_card_icon.png";
import visaLogo from "../assets/visa_color_icon.png";
import amexLogo from "../assets/amex_icon.svg";

export type CardBrandKey = "visa" | "mastercard" | "amex";

export interface CardBrandInfo {
  key: CardBrandKey;
  label: string;
  logo: string;
  altKey: string;
  regex: RegExp;
}

export const CARD_BRANDS: Record<CardBrandKey, CardBrandInfo> = {
  visa: {
    key: "visa",
    label: "Visa",
    logo: visaLogo,
    altKey: "card.visaAlt",
    regex: /^4/,
  },
  mastercard: {
    key: "mastercard",
    label: "Mastercard",
    logo: mastercardLogo,
    altKey: "card.mastercardAlt",
    regex: /^5[1-5]|^2[2-7]/,
  },
  amex: {
    key: "amex",
    label: "Amex",
    logo: amexLogo,
    altKey: "card.amexAlt",
    regex: /^3[47]/,
  },
};

export const DEFAULT_ALLOWED_BRANDS: CardBrandKey[] = ["visa", "mastercard"];

export function detectCardBrand(cardNumber: string): CardBrandKey | null {
  const cleaned = cardNumber.replace(/\s/g, "");
  for (const brand of Object.values(CARD_BRANDS)) {
    if (brand.regex.test(cleaned)) return brand.key;
  }
  return null;
}

export function getBrandInfo(key: string): CardBrandInfo | undefined {
  return CARD_BRANDS[key as CardBrandKey];
}
